/**
 * CandyOnline QLS Stock Guard v2
 *
 * Storefront-laag die het echte QLS-voorraad ophaalt en het UI overrijdt.
 *
 * v2 changes:
 *   - Ondersteunt naast data-sku ook data-variant-id (Shopify standaard)
 *   - Verbergt hele product-cards bij OOS (display:none) ipv alleen knop disablen
 *   - Werkt op PDP, collection-pagina's, /pages/*, search, en custom landings
 *
 * Hard limits:
 *   - 500ms timeout per fetch (fail-open)
 *   - max 100 items per batch-call
 *   - debounce 1.5s tussen DOM-mutation rescans
 *
 * Endpoint:
 *   https://admin.candyonline.nl/voorraad-public.php?skus=...&variants=...
 *
 * Console: window.QLS_GUARD_DEBUG = true voor verbose logging.
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://admin.candyonline.nl/voorraad-public.php';
  var FETCH_TIMEOUT_MS = 800;
  var BATCH_MAX = 100;
  var DEBOUNCE_MS = 1500;
  var OOS_LABEL = 'Helaas niet meer leverbaar';
  // Selectors die we als "card-container" zien - bij OOS van het inner data-variant-id/data-sku
  // element wordt het closest matching element gehidden.
  var CARD_SELECTORS = [
    'article.hs-card',
    '.hs-card',
    '.product-card',
    '.product-card-wrapper',
    '.card-wrapper',
    '.grid__item',
    '.product-grid-item',
    '.js-product-card',
    'product-card',
    '[data-product-card]'
  ].join(',');

  function log() { if (window.QLS_GUARD_DEBUG) console.log.apply(console, ['[qls-guard]'].concat([].slice.call(arguments))); }
  function warn() { console.warn.apply(console, ['[qls-guard]'].concat([].slice.call(arguments))); }

  function fetchStock(opts) {
    var skus = opts.skus || [];
    var variants = opts.variants || [];
    if (!skus.length && !variants.length) return Promise.resolve({ skus: {}, variants: {} });
    skus = skus.slice(0, BATCH_MAX);
    variants = variants.slice(0, BATCH_MAX);
    var params = [];
    if (skus.length) params.push('skus=' + encodeURIComponent(skus.join(',')));
    if (variants.length) params.push('variants=' + encodeURIComponent(variants.join(',')));
    var url = ENDPOINT + '?' + params.join('&');
    return new Promise(function (resolve) {
      var resolved = false;
      var done = function (val) { if (resolved) return; resolved = true; resolve(val); };
      var timer = setTimeout(function () { done({ skus: {}, variants: {} }); }, FETCH_TIMEOUT_MS);
      fetch(url, { method: 'GET', cache: 'no-store', mode: 'cors' })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (data) {
          clearTimeout(timer);
          done({ skus: (data && data.skus) || {}, variants: (data && data.variants) || {} });
        })
        .catch(function (e) { clearTimeout(timer); warn('fetch error, fail-open', e); done({ skus: {}, variants: {} }); });
    });
  }

  function findVariantSkuFromProductJson() {
    var scripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var json = JSON.parse(scripts[i].textContent);
        var items = Array.isArray(json) ? json : [json];
        for (var j = 0; j < items.length; j++) {
          if (items[j]['@type'] === 'Product' && items[j].sku) return String(items[j].sku);
          if (items[j].offers && items[j].offers.sku) return String(items[j].offers.sku);
        }
      } catch (e) {}
    }
    var meta = document.querySelector('meta[itemprop="sku"]');
    if (meta && meta.content) return String(meta.content);
    return null;
  }

  function findAddToCartButtons(root) {
    root = root || document;
    var sels = [
      'button[name="add"]',
      'form[action="/cart/add"] button[type="submit"]',
      '.js-quick-add',
      '.product-form__submit',
      'product-form button',
      '[data-add-to-cart]',
      '.hs-card__add',
      '[data-hs-add]'
    ];
    return root.querySelectorAll(sels.join(','));
  }

  function injectStyles() {
    if (document.getElementById('qls-guard-styles')) return;
    var s = document.createElement('style');
    s.id = 'qls-guard-styles';
    s.textContent =
      '.qls-guard-hidden{display:none !important;}' +
      '.qls-guard-oos-btn{opacity:.5 !important;cursor:not-allowed !important;}';
    document.head.appendChild(s);
  }

  function hideCard(innerEl) {
    try {
      // Nooit cart-drawer regels verwijderen - de winkelmand is geen product-listing.
      // Deal-varianten ([DEAL], limit-1, MEGA snoepmix, Dr Pepper 12-pack) zijn in QLS
      // niet op variant-ID bekend (found:false); zonder deze guard nukte hideCard()
      // die regels uit de drawer (puur visueel, server-cart bleef intact).
      if (innerEl.closest && innerEl.closest('.candy-drawer__item')) return;
      var card = innerEl.closest(CARD_SELECTORS) || innerEl;
      if (card.dataset.qlsGuardHidden === '1') return;
      card.dataset.qlsGuardHidden = '1';
      card.remove();
      log('hidden card for', innerEl.dataset.variantId || innerEl.dataset.sku);
    } catch (e) { warn('hideCard err', e); }
  }

  function disableAddButton(btn, label) {
    try {
      if (!btn || btn.dataset.qlsGuardOos === '1') return;
      btn.dataset.qlsGuardOos = '1';
      btn.dataset.qlsGuardOriginalText = btn.textContent || '';
      btn.disabled = true;
      btn.classList.add('qls-guard-oos-btn');
      if (btn.textContent && btn.textContent.trim().length) btn.textContent = label || OOS_LABEL;
    } catch (e) {}
  }

  function handlePDP() {
    var sku = findVariantSkuFromProductJson();
    if (!sku) { log('PDP: geen SKU gevonden'); return; }
    log('PDP SKU:', sku);
    fetchStock({ skus: [sku] }).then(function (data) {
      var s = data.skus[sku];
      // Fail-closed: als SKU niet in QLS (found=false) of available<=0 ? blokkeer.
      // Dit pakt SKUs die QLS niet kent (zoals [DEAL] dupes die alleen via Shopify drift "op voorraad" lijken).
      var blocked = !s || !s.found || s.available <= 0;
      if (!blocked) return;
      log('PDP: blocked', sku, s);
      var btns = findAddToCartButtons(document);
      for (var i = 0; i < btns.length; i++) disableAddButton(btns[i], OOS_LABEL);
      // Plus: intercept form submit als extra zekerheid (button.disabled werkt soms niet bij theme-overrides)
      var forms = document.querySelectorAll('form[action*="/cart/add"]');
      for (var j = 0; j < forms.length; j++) {
        forms[j].addEventListener('submit', function (e) {
          e.preventDefault(); e.stopPropagation();
          alert(OOS_LABEL);
        }, true);
      }
    });
  }

  var lastCardScan = 0;
  function handleCards(root) {
    var now = Date.now();
    if (now - lastCardScan < DEBOUNCE_MS) return;
    lastCardScan = now;
    root = root || document;

    // SKU-based cards (data-sku)
    var skuMap = {};
    var skuNodes = root.querySelectorAll('[data-sku]');
    for (var i = 0; i < skuNodes.length; i++) {
      var sku = skuNodes[i].getAttribute('data-sku');
      if (!sku) continue;
      if (skuNodes[i].closest('.candy-drawer__item')) continue; // cart-drawer regels overslaan
      if (!skuMap[sku]) skuMap[sku] = [];
      skuMap[sku].push(skuNodes[i]);
    }

    // Variant-id-based cards (data-variant-id) - Shopify standaard
    var varMap = {};
    var varNodes = root.querySelectorAll('[data-variant-id]');
    for (var j = 0; j < varNodes.length; j++) {
      var vid = varNodes[j].getAttribute('data-variant-id');
      if (!vid || !/^\d+$/.test(vid)) continue;
      if (varNodes[j].closest('.candy-drawer__item')) continue; // cart-drawer regels overslaan
      if (!varMap[vid]) varMap[vid] = [];
      varMap[vid].push(varNodes[j]);
    }

    var skus = Object.keys(skuMap);
    var vids = Object.keys(varMap);
    if (!skus.length && !vids.length) return;
    log('cards: checking', skus.length, 'SKUs +', vids.length, 'variant-ids');

    fetchStock({ skus: skus, variants: vids }).then(function (data) {
      // Process SKU results
      Object.keys(skuMap).forEach(function (sku) {
        var info = data.skus[sku];
        var els = skuMap[sku];
        if (!info || !info.found || info.available <= 0) {
          els.forEach(function (el) { hideCard(el); });
        }
      });
      // Process variant-id results
      Object.keys(varMap).forEach(function (vid) {
        var info = data.variants[vid];
        var els = varMap[vid];
        if (!info || !info.found || info.available <= 0) {
          els.forEach(function (el) { hideCard(el); });
        }
      });
    });
  }

  function handleCart() {
    if (!window.fetch) return;
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var skus = (cart.items || []).map(function (it) { return it.sku; }).filter(Boolean);
        if (!skus.length) return;
        log('cart: checking', skus.length, 'SKUs');
        return fetchStock({ skus: skus }).then(function (data) {
          var problems = [];
          (cart.items || []).forEach(function (it) {
            var info = data.skus[it.sku];
            if (!info || !info.found || info.available < it.quantity) {
              problems.push({ sku: it.sku, title: it.product_title, requested: it.quantity, available: (info ? info.available : null) });
            }
          });
          if (problems.length) {
            warn('cart problems:', problems);
            var checkoutBtns = document.querySelectorAll('[name="checkout"], button[name="checkout"], .cart__checkout, .cart-checkout, [href$="/checkout"]');
            for (var i = 0; i < checkoutBtns.length; i++) disableAddButton(checkoutBtns[i], 'Item(s) niet leverbaar');
          }
        });
      })
      .catch(function (e) { warn('cart err, fail-open', e); });
  }

  function init() {
    injectStyles();
    var path = window.location.pathname || '';
    log('init v2', path);
    if (/^\/products\//.test(path)) handlePDP();
    if (/^\/cart/.test(path)) handleCart();
    // catch-all: scan voor cards op iedere pagina
    handleCards(document);
  }

  function observeMutations() {
    if (!window.MutationObserver) return;
    var obs = new MutationObserver(function (muts) {
      var hasAdded = false;
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { hasAdded = true; break; }
      }
      if (hasAdded) handleCards(document);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); observeMutations(); });
  } else {
    init();
    observeMutations();
  }
})();
